"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRepositoryConfiguration = exports.DEFAULT_SERVICE_TOKEN = void 0;
const default_content_types_1 = require("@sensenet/default-content-types");
/**
 * The default Sense/Net OData Service token (odata.svc)
 */
exports.DEFAULT_SERVICE_TOKEN = 'odata.svc';
exports.defaultRepositoryConfiguration = {
    chunkSize: 1000000,
    defaultEnableAutofilters: false,
    defaultEnableLifespanfilter: false,
    defaultInlineCount: 'allpages',
    defaultMetadata: 'no',
    defaultSelect: ['DisplayName', 'Description', 'Icon'],
    defaultTop: 10000,
    oDataToken: exports.DEFAULT_SERVICE_TOKEN,
    repositoryUrl: '',
    requiredSelect: ['Id', 'Path', 'Name', 'Type'],
    schemas: default_content_types_1.SchemaStore,
    identityServerUrl: '',
};
//# sourceMappingURL=RepositoryConfiguration.js.map